import { TypeDefinition } from "../models/generic";

export class ContactTypes {
    public static Business: TypeDefinition = { id: 1, name: "Business" };
    public static Private: TypeDefinition = { id: 2, name: "Private" };

    public static Values: TypeDefinition[] = [
        ContactTypes.Business,
        ContactTypes.Private,
    ];
}



// WEBPACK FOOTER //
// ./src/domain/ContactTypes.ts